import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component, Prop, Watch, Emit } from "vue-property-decorator";
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
import MaterialCard from "@/components/material/Card.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
let CustomerInformationView = class CustomerInformationView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.validations = {
            name: {
                required,
                maxLength: maxLength(10)
            },
            email: { required, email },
            select: { required },
            checkbox: {
                checked(val) {
                    return val;
                }
            }
        };
        this.customer = {};
        this.states = {
            AL: "Alabama",
            AK: "Alaska",
            AS: "American Samoa",
            AZ: "Arizona",
            AR: "Arkansas",
            CA: "California",
            CO: "Colorado",
            CT: "Connecticut",
            DE: "Delaware",
            DC: "District Of Columbia",
            FM: "Federated States Of Micronesia",
            FL: "Florida",
            GA: "Georgia",
            GU: "Guam",
            HI: "Hawaii",
            ID: "Idaho",
            IL: "Illinois",
            IN: "Indiana",
            IA: "Iowa",
            KS: "Kansas",
            KY: "Kentucky",
            LA: "Louisiana",
            ME: "Maine",
            MH: "Marshall Islands",
            MD: "Maryland",
            MA: "Massachusetts",
            MI: "Michigan",
            MN: "Minnesota",
            MS: "Mississippi",
            MO: "Missouri",
            MT: "Montana",
            NE: "Nebraska",
            NV: "Nevada",
            NH: "New Hampshire",
            NJ: "New Jersey",
            NM: "New Mexico",
            NY: "New York",
            NC: "North Carolina",
            ND: "North Dakota",
            MP: "Northern Mariana Islands",
            OH: "Ohio",
            OK: "Oklahoma",
            OR: "Oregon",
            PW: "Palau",
            PA: "Pennsylvania",
            PR: "Puerto Rico",
            RI: "Rhode Island",
            SC: "South Carolina",
            SD: "South Dakota",
            TN: "Tennessee",
            TX: "Texas",
            UT: "Utah",
            VT: "Vermont",
            VI: "Virgin Islands",
            VA: "Virginia",
            WA: "Washington",
            WV: "West Virginia",
            WI: "Wisconsin",
            WY: "Wyoming"
        };
    }
    async mounted() {
        this.user = await this.authService.getUser();
        this.customer = {};
        this.customer.firstName = this.selectedCustomer.firstName;
        this.customer.lastName = this.selectedCustomer.lastName;
        this.customer.email = this.selectedCustomer.email;
        this.customer.organizationName = this.selectedCustomer.organizationName;
        this.customer.address1 = this.selectedCustomer.address1;
        this.customer.address2 = this.selectedCustomer.address2;
        this.customer.city = this.selectedCustomer.city;
        this.customer.state = this.selectedCustomer.state;
        this.customer.zipCode = this.selectedCustomer.zipCode;
        this.customer.country = this.selectedCustomer.country;
        this.customer.customerId = this.selectedCustomer.customerId;
        this.customer.sourceReferenceId = this.selectedCustomer.sourceReferenceId;
        this.customer.accountingCustomerId = this.selectedCustomer.accountingCustomerId;
        this.customer.phone = this.selectedCustomer.phone;
    }
    get customerName() {
        console.log("Getting customer name: " + this.isNewCustomer);
        if (this.isNewCustomer === true) {
            return "New Customer";
        }
        else {
            return this.firstName.concat(" ").concat(this.lastName);
        }
    }
    onCustomerChanged(newCustomer, oldCustomer) {
        this.customer = {};
        this.customer.firstName = newCustomer.firstName;
        this.customer.lastName = newCustomer.lastName;
        this.customer.email = newCustomer.email;
        this.customer.organizationName = newCustomer.organizationName;
        this.customer.address1 = newCustomer.address1;
        this.customer.address2 = newCustomer.address2;
        this.customer.city = newCustomer.city;
        this.customer.state = newCustomer.state;
        this.customer.zipCode = newCustomer.zipCode;
        this.customer.country = newCustomer.country;
        this.customer.customerId = newCustomer.customerId;
        this.customer.sourceReferenceId = newCustomer.sourceReferenceId;
        this.customer.accountingCustomerId = newCustomer.accountingCustomerId;
        this.customer.phone = newCustomer.phone;
        this.$v.$reset();
    }
    get accountingCustomerId() {
        return this.customer.accountingCustomerId;
    }
    get firstName() {
        return this.customer.firstName;
    }
    set firstName(value) {
        this.customer.firstName = value;
    }
    get lastName() {
        return this.customer.lastName;
    }
    set lastName(value) {
        this.customer.lastName = value;
    }
    get organizationName() {
        return this.customer.organizationName;
    }
    set organizationName(value) {
        this.customer.organizationName = value;
    }
    get email() {
        return this.customer.email;
    }
    set email(value) {
        this.customer.email = value;
    }
    get address1() {
        return this.customer.address1;
    }
    set address1(value) {
        this.customer.address1 = value;
    }
    get address2() {
        return this.customer.address2;
    }
    set address2(value) {
        this.customer.address2 = value;
    }
    get city() {
        return this.customer.city;
    }
    set city(value) {
        this.customer.city = value;
    }
    get state() {
        return this.customer.state;
    }
    set state(value) {
        this.customer.state = value;
    }
    get phone() {
        return this.customer.phone;
    }
    set phone(value) {
        this.customer.phone = value;
    }
    get organizationNameErrors() {
        const errors = [];
        if (!this.$v.organizationName.$dirty)
            return errors;
        !this.$v.organizationName.maxLength &&
            errors.push("Organization Name must be at most 10 characters long");
        !this.$v.organizationName.required &&
            errors.push("Organization Name is required.");
        return errors;
    }
    get firstNameErrors() {
        const errors = [];
        if (!this.$v.firstName.$dirty)
            return errors;
        !this.$v.firstName.maxLength &&
            errors.push("First Name must be at most 10 characters long");
        !this.$v.firstName.required && errors.push("First Name is required.");
        return errors;
    }
    get lastNameErrors() {
        const errors = [];
        if (!this.$v.lastName.$dirty)
            return errors;
        !this.$v.lastName.maxLength &&
            errors.push("Last Name must be at most 10 characters long");
        !this.$v.lastName.required && errors.push("Last Name is required.");
        return errors;
    }
    get emailErrors() {
        const errors = [];
        if (!this.$v.email.$dirty)
            return errors;
        !this.$v.email.email && errors.push("Must be valid e-mail");
        !this.$v.email.required && errors.push("E-mail is required");
        return errors;
    }
    get address1Errors() {
        const errors = [];
        if (!this.$v.address1.$dirty)
            return errors;
        !this.$v.address1.maxLength &&
            errors.push("Address 1 must be at most 10 characters long");
        !this.$v.address1.required && errors.push("Address 1 is required.");
        return errors;
    }
    get cityErrors() {
        const errors = [];
        if (!this.$v.city.$dirty)
            return errors;
        !this.$v.city.maxLength &&
            errors.push("City must be at most 10 characters long");
        !this.$v.city.required && errors.push("City is required.");
        return errors;
    }
    get stateErrors() {
        const errors = [];
        if (!this.$v.state.$dirty)
            return errors;
        !this.$v.state.maxLength &&
            errors.push("State must be at most 10 characters long");
        !this.$v.state.required && errors.push("State is required.");
        return errors;
    }
    get phoneErrors() {
        const errors = [];
        if (!this.$v.phone.$dirty)
            return errors;
        !this.$v.state.maxLength &&
            errors.push("Phone must be at most 10 characters long");
        !this.$v.phone.required && errors.push("Phone is required.");
        return errors;
    }
    submit(event) {
        console.log("Submit clicked: " + JSON.stringify(event));
        if (this.$v.$invalid) {
            console.log("Not all fields are valid");
        }
        else {
            console.log("Valid form, submit it");
            this.selectedCustomer.firstName = this.customer.firstName;
            this.selectedCustomer.lastName = this.customer.lastName;
            this.selectedCustomer.organizationName = this.customer.organizationName;
            this.selectedCustomer.email = this.customer.email;
            this.selectedCustomer.address1 = this.customer.address1;
            this.selectedCustomer.address2 = this.customer.address2;
            this.selectedCustomer.city = this.customer.city;
            this.selectedCustomer.state = this.customer.state;
            this.selectedCustomer.zipCode = this.customer.zipCode;
            this.selectedCustomer.phone = this.customer.phone;
        }
        return this.customer;
    }
    cancel(event) {
        console.log("Cancel clicked: " + JSON.stringify(event));
        return null;
    }
};
tslib_1.__decorate([
    Prop({})
], CustomerInformationView.prototype, "selectedCustomer", void 0);
tslib_1.__decorate([
    Prop(Boolean)
], CustomerInformationView.prototype, "isNewCustomer", void 0);
tslib_1.__decorate([
    Watch("selectedCustomer")
], CustomerInformationView.prototype, "onCustomerChanged", null);
tslib_1.__decorate([
    Emit()
], CustomerInformationView.prototype, "submit", null);
tslib_1.__decorate([
    Emit()
], CustomerInformationView.prototype, "cancel", null);
CustomerInformationView = tslib_1.__decorate([
    Component({
        name: "CustomerInformation",
        mixins: [validationMixin],
        validations: {
            firstName: {
                required,
                maxLength: maxLength(10)
            },
            lastName: {
                required,
                maxLength: maxLength(10)
            },
            organizationName: {
                required,
                maxLength: maxLength(50)
            },
            email: { required, email },
            address1: {
                required,
                maxLength: maxLength(50)
            },
            city: {
                required,
                maxLength: maxLength(50)
            },
            state: {
                required,
                maxLength: maxLength(2)
            },
            phone: {
                required,
                maxLength: maxLength(10)
            }
        },
        components: {
            MaterialCard
        }
    })
], CustomerInformationView);
export default CustomerInformationView;
